import * as React from "react";
import { cn } from "../../lib/utils";

const baseClasses =
  "inline-flex items-center rounded-full px-2.5 pt-[0.30rem] pb-[0.25rem] text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2";

const variantClasses = {
  default:
    "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
  secondary:
    "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
  destructive:
    "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
  outline: "text-foreground",
};

function Badge({ className = "", variant = "default", ...props }) {
  return (
    <div
      className={cn(baseClasses, variantClasses[variant] || "", className)}
      {...props}
    />
  );
}

export { Badge };
